import React, { useState, useEffect } from 'react';
import { CardContent, Box, Typography, Slider, TextField, Grid } from '@mui/material';
import { useAppContext } from '../context/AppContext'; // update path as needed

const KidsPlanning = () => {
  const { state, actions } = useAppContext();
  const [numKids, setNumKids] = useState(0);
  const [kidsInfo, setKidsInfo] = useState([]);

  // Initialize component with existing data from context
  useEffect(() => {
    if (state.kidsInfo && state.kidsInfo.length > 0) {
      const updatedKids = state.kidsInfo.map(kid => ({
        ...kid,
        Age: kid.Age || (currentYear - parseInt(kid.yearOfBirth || 0)),
      }));
      setKidsInfo(updatedKids);
      setNumKids(updatedKids.length);
  
      // Validation logic: ensure name and yearOfBirth are filled
      const isValid = updatedKids.every(kid => kid.name?.trim() !== '' && /^[12]\d{3}$/.test(String(kid.yearOfBirth || '')));
      // const isValid = updatedKids.every(kid => kid.name?.trim() !== '' && kid.yearOfBirth !== 0);
      actions.updateFormData('kidsPlanningValid', isValid);
    } else {
      actions.updateFormData('kidsPlanningValid', true); // No kids = valid
    }
  }, [state.kidsInfo]);
  
  

  const handleSliderChange = (event, newValue) => {
    setNumKids(newValue);
    const updatedKids = [];
    for (let i = 0; i < newValue; i++) {
      updatedKids.push(kidsInfo[i] || { name: '', yearOfBirth: 0 });
    }
    setKidsInfo(updatedKids);
    actions.updateFormData('kidsInfo', updatedKids);
  };

  const handleInputChange = (index, field, value) => {
    const updated = [...kidsInfo];
    if(field == "yearOfBirth"){
      updated[index][field] = parseInt(value);
      updated[index]["Age"] = Number(currentYear - parseInt(value || 0));
    }
    else{
      updated[index][field] = value;
    }
    setKidsInfo(updated);
    actions.updateFormData('kidsInfo', updated);
    console.log("kidsInfo---->",kidsInfo)
  };

  const currentYear = new Date().getFullYear();

  return (
    <CardContent>
      <Box>
        <Typography variant="h6" sx={{mb:2, color:'primary.main'}} gutterBottom>
        Children’s Education
        </Typography>
        
        <Typography variant="body1" sx={{ mb: 1 }}>
          How many children do you want to plan for?
        </Typography>
        
        
          <Slider
            value={numKids}
            onChange={handleSliderChange}
            step={1}
            marks={[
              { value: 0, label: 'None' },
              { value: 1, label: '1' },
              { value: 2, label: '2' },
              { value: 3, label: '3' }
            ]}
            min={0}
            max={3}
            valueLabelDisplay="auto"
          />

        {numKids > 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Please enter name and birth year:
          </Typography>
        )}

        {kidsInfo.map((kid, index) => (
          <Box key={index} sx={{mb: 2 }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            Child {index + 1}
          </Typography>

          <Grid container spacing={2} wrap="nowrap" alignItems="flex-start">
            <Grid item md={8} sm={8}>
            <TextField
              label="Name"
              value={kid.name || ''}
              onChange={(e) => handleInputChange(index, 'name', e.target.value)}
              size="small"
              fullWidth
              // error={!kid.name || kid.name.trim() === ""}   // error if empty or spaces only
              // helperText={
              //   !kid.name || kid.name.trim() === "" 
              //     ? "Please enter a valid name" 
              //     : " "
              // }
              FormHelperTextProps={{
                sx: { minHeight: 20, ml: 0 }
              }}
            />
            </Grid>

            <Grid item md={4} sm={4}>
              {(() => {
                const y = kid.yearOfBirth;
                const validYear = /^[12]\d{3}$/.test(String(y || ''));
                // const age = y ? (currentYear - Number(y)) : null;
                const msg =
                  !y ? '' :
                  !validYear ? 'Please enter a valid year' : '';
                  // (age > 25) ? 'Child age should be less than 25' : '';

                return (
                  <TextField
                    label="Birth Year"
                    value={y || ''}
                    type="tel"
                    inputMode="numeric"
                    inputProps={{ min: currentYear - 25, max: currentYear + 1, step: 1 }}
                    onChange={(e) => handleInputChange(index, 'yearOfBirth', e.target.value)}
                    size="small"
                    fullWidth
                    error={Boolean(msg)}
                    helperText={msg || ' '}                      // always reserve space
                    FormHelperTextProps={{
                      sx: { minHeight: 20, visibility: msg ? 'visible' : 'hidden', ml: 0 }
                    }}
                  />
                );
              })()}
            </Grid>
          </Grid>
        </Box>        
        ))}
      </Box>
    </CardContent>
  );
};

export default KidsPlanning;
